import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter as Router } from 'react-router-redux'
import { retry } from 'common/utils/retry'

import 'common/utils/footer'
import { SpinnerSuspense } from 'common/components/chips/StyledSuspense'
import { initErrorLogging } from 'common/utils/errors'
import {
  getOutboundTimeFromUrl,
  getInboundTimeFromUrl,
  cleanUpUrl,
} from 'tickets/utils/urlUtils'
import { ticketsSearchPath } from 'common/utils/paths'
import {
  getInitialPathParameters,
} from 'common/utils/context'

import create from 'tickets/redux/create'
import filtersOperations from 'tickets/redux/modules/filters/operations'
import locationOperations from 'tickets/redux/modules/location/operations'
import TicketsAppContainer from 'tickets/containers/TicketsAppContainer'
import L10nContainer from 'common/containers/L10nContainer/L10nContainer'
import ErrorBoundaryContainer from 'common/containers/ErrorBoundaryContainer'
import history from 'common/utils/history'
import ensureIntlSupport from 'common/utils/ensureIntlSupport'

const ModalRootContainer = React.lazy(() => retry(() => import(/* webpackPrefetch: -10 */ 'tickets/containers/ModalRootContainer')))
initErrorLogging(history)
const store = create

const initialPathParameters = getInitialPathParameters()
const initialLanguageCode = initialPathParameters?.languageCode ?? 'en'
const initialOrigin = initialPathParameters?.originCanonical
const initialDestination = initialPathParameters?.destinationCanonical

// Reset the URL if it contains invalid parameters.
cleanUpUrl(initialOrigin, initialDestination, initialLanguageCode)

store.dispatch(locationOperations.initialiseOrigin(initialOrigin, initialLanguageCode))
store.dispatch(locationOperations.initialiseDestination(initialDestination, initialLanguageCode))

// Sets search times for all time aware modes
const outboundTime = getOutboundTimeFromUrl()
const inboundTime = getInboundTimeFromUrl()
if (outboundTime != null) {
  store.dispatch(filtersOperations.outboundDepartureTimesInitialized(outboundTime))
}
if (inboundTime != null) {
  store.dispatch(filtersOperations.inboundDepartureTimesInitialized(inboundTime))
}

ensureIntlSupport(initialLanguageCode).then(
  render(
    <Provider store={store}>
      <ErrorBoundaryContainer>
        <L10nContainer>
          <Router history={history}>
            <div>
              <Switch>
                <Route
                  path={ticketsSearchPath}
                  render={(routeProps) => <TicketsAppContainer {...routeProps} />}
                />
              </Switch>
              <SpinnerSuspense>
                <ModalRootContainer />
              </SpinnerSuspense>
            </div>
          </Router>
        </L10nContainer>
      </ErrorBoundaryContainer>
    </Provider>
    ,
    document.getElementById('app')
  )
)
